a.issue = (function(){
	var my = {
		calcDuration:function(form,errormsg){
			var end = $('input[name="deadline"]',form).val();
			var duration = moment.duration(moment(end, 'YYYY-MM-DD HH:mm:ss').diff(moment()));
			$('*[data-area="duration"]').css('color','#000');
			if (duration.asSeconds()<300) {
				$('*[data-area="duration"]').css('color','red').empty().append(errormsg);
			}
			else {
				$('*[data-area="duration"]').empty().append(formatDuration(duration));
			}
			function formatDuration(period) {
				var parts = [];
				var duration = moment.duration(period);
				// return nothing when the duration is falsy or not correctly parsed (P0D)
				if(!duration || duration.toISOString() === "P0D") return;
				if(duration.years() >= 1) {
					var years = Math.floor(duration.years());
					parts.push(years+" "+(years > 1 ? "years" : "year"));
				}
				if(duration.months() >= 1) {
					var months = Math.floor(duration.months());
					parts.push(months+" "+(months > 1 ? "months" : "month"));
				}
				if(duration.days() >= 1) {
					var days = Math.floor(duration.days());
					parts.push(days+" "+(days > 1 ? "days" : "day"));
				}
				if(duration.hours() >= 1) {
					var hours = Math.floor(duration.hours());
					parts.push(hours+" "+(hours > 1 ? "hours" : "hour"));
				}
				if(duration.minutes() >= 1) {
					var minutes = Math.floor(duration.minutes());
					parts.push(minutes+" "+(minutes > 1 ? "minutes" : "minute"));
				}
				if(duration.seconds() >= 1) {
					//var seconds = Math.floor(duration.seconds());
					//parts.push(seconds+" "+(seconds > 1 ? "seconds" : "second"));
				}
				return parts.join(", ");
			}
		}
	}
	return my;
}());